import { memo } from "react";
import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

import { DEFAULT_TIMEBAND } from "../consts/strings";
import {
  COLLECTIONS_PLAN_TYPE,
  DELIVERY_PLAN_TYPES,
} from "../consts/planTypes";
import { palette } from "../theme/palette";

import { selectedTimeBandSelector } from "../reducers/ownApp/selectors";
import {
  getMatrixProfileType,
  isEditOneModeSelector,
  routeInEditSelector,
} from "../reducers/matrixProfile/selectors";

import { TimeSlider } from "./TimeSlider";
import { View } from "./View";
import { CollectionDefaultBar } from "./CollectionDefaultBar/CollectionDefaultBar";

const useStyles = makeStyles({
  barContainer: {
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: 100,
  },
  currentlyEditing: {
    backgroundColor: palette.orange,
    display: "inline-block",
    padding: "5px",
    fontSize: "13px",
  },
});

const getBarForType = (type, isEditOneMode, selectedTimeBand) => {
  if (type === COLLECTIONS_PLAN_TYPE) return <CollectionDefaultBar />;
  else if (DELIVERY_PLAN_TYPES.includes(type))
    return (
      <TimeSlider
        disabled={isEditOneMode || selectedTimeBand === DEFAULT_TIMEBAND}
      />
    );
  else return null;
};

export const AppBar = memo(() => {
  const routeInEdit = useSelector(routeInEditSelector);
  const isEditOneMode = useSelector(isEditOneModeSelector);
  const selectedType = useSelector(getMatrixProfileType);
  const selectedTimeBand = useSelector(selectedTimeBandSelector);
  const styles = useStyles();

  return (
    <View className={styles.barContainer}>
      {getBarForType(selectedType, isEditOneMode, selectedTimeBand)}
      {isEditOneMode && routeInEdit && (
        <View className={styles.currentlyEditing}>
          Currently Editing {routeInEdit && routeInEdit.routeCode}
        </View>
      )}
    </View>
  );
});
